<template>
  <div id="video_voice" class="relativeItem">
    <!--直播间区域-->
    <div class="live relativeItem" :class="{ living: ready }">
      <!--封面-->
      <img
        :src="info.showcover"
        class="cover imgBlock noevents-img filter_cover"
        v-if="is_over"
      />

      <!--电台界面-->
      <div class="bs relativeItem" v-if="!is_over && user_list.length > 0">
        <!--主播头像-->
        <div
          class="ac-head absoluteItem"
          :class="{ 'in-head': index == 0 }"
          v-for="(n, index) in num_bs"
          :key="index"
        >
          <img
            :src="user_list[index].avatar"
            class="imgBlock noevents-img head-img"
            v-if="user_list[index].tousernickname != ''"
            onerror="this.src='http://oss.3yakj.com/application_static_data/static_data/publicimg/img.jpg'"
          />
          <img
            src="../../assets/share/bs_share(2).png"
            class="imgBlock noevents-img head-img"
            v-else
          />

          <img
            src="../../assets/share/bs_share(1).png"
            class="sign-img imgBlock noevents-img absoluteItem centerX"
            v-if="index == 0 && user_list.length > 1"
          />

          <p
            class="name apostrophe absoluteItem centerX"
            v-if="user_list[index].tousernickname != ''"
          >
            {{ user_list[index].tousernickname }}
          </p>
          <p class="name apostrophe absoluteItem centerX" v-else>
            {{ user_list[index].seat_id }}号位
          </p>
        </div>
        <!--透明遮罩层-->
        <a class="allA" id="live-download4">
          <img
            src="../../assets/share/video_shere(1).png"
            class="imgBlock noevents-img absoluteItem centerImg"
            style="width: 20%"
            v-if="!is_login"
          />
        </a>
        <!--底部背景-->
        <img
          :src="cover_img_src"
          class="bk_cover_img imgBlock"
          v-if="cover_img_src != ''"
        />
        <!--底部遮罩层-->
        <div class="b_cover absoluteItem centerImg"></div>
      </div>

      <!--聊天信息-->
      <zhibochat
        class="chat"
        v-if="show_chat"
        @up_heat="upheat"
        @uppoint="uppoint"
        @end="end_palying"
      ></zhibochat>

      <!--头像和榜单-->
      <div class="top flex-box absoluteItem" v-show="!is_over">
        <!--头像区域-->
        <div class="head flex-box relativeItem">
          <a class="allA" id="live-download1"></a>
          <div class="img">
            <img :src="info.avatar" class="mlz-img imgBlock noevents-img" />
          </div>
          <div class="text">
            <p class="p1 apostrophe">{{ info.nickname }}</p>
            <p class="p2">{{ info.heat }}热度</p>
          </div>
          <img
            src="../../assets/share/video_shere(6).png"
            class="gz imgBlock noevents-img"
          />
        </div>

        <!--榜单区域-->
        <div class="list-shell relativeItem">
          <a class="allA" id="live-download2"></a>
          <ul class="flex-box">
            <li
              class="relativeItem"
              v-for="(n, index) in wathcer"
              :key="index"
              v-show="index < 4"
            >
              <img
                src="../../assets/share/live_share(4).png"
                class="head-shell imgBlock absoluteItem"
                v-if="index < 3"
              />

              <img :src="n.avatar" class="avatar imgBlock noevents-img" />
              <span class="imgBlock absoluteItem centerX">{{ n.honor }}</span>
            </li>

            <!--虚化层-->
            <!-- <span class="xuhua absoluteItem centerY"></span> -->
          </ul>

          <!--最右侧按钮-->
          <img
            src="../../assets/share/live_share(8).png"
            class="moer-list imgBlock noevents-img absoluteItem centerY"
          />
        </div>
      </div>

      <!--魅力值和朱贝号-->
      <div class="mlz_n absoluteItem flex-box" v-show="!is_over">
        <div class="mlz flex-box relativeItem">
          <img
            src="../../assets/share/live_share(5).png"
            class="sign imgBlock noevents-img absoluteItem centerY"
          />
          <img
            src="../../assets/share/live_share(7).png"
            class="mlz-img imgBlock noevents-img"
          />
          {{ info.totalpoint }}
          <img
            src="../../assets/share/live_share.png"
            class="arrow absoluteItem centerY imgBlock noevents-img"
          />
        </div>
        <div class="zbh flex-box">
          <img src="../../assets/share/live_share(9).png" class="noevents-img" />&nbsp;{{
            info.roomnumber
          }}
        </div>
      </div>

      <!--底部按钮-->
      <div class="b-bottom absoluteItem centerX" v-show="!is_over">
        <a id="live-download3" class="allA"></a>
        <img src="../../assets/share/live_share(3).png" class="img1 noevents-img" />
        <img src="../../assets/share/live_share(6).png" class="img2 noevents-img" />
        <img src="../../assets/share/live_share(1).png" class="img3 noevents-img" />
      </div>
    </div>

    <!--直播结束区域-->
    <div class="over absoluteItem" v-show="is_over">
      <p class="p1">本场直播已结束</p>
      <p class="p2">
        <img :src="info.avatar" class="imgBlock noevents-img" />
      </p>
      <p class="p3">{{ info.nickname }}</p>
      <p class="p4">朱贝号{{ info.roomnumber }}</p>
      <div class="btn" id="live-download5">
        <img src="../../assets/share/live_share(2).png" class="imgBlock noevents-img" />
      </div>
    </div>

    <!--GME对象-->
    <div id="gme-audio-wrap"></div>
  </div>
</template>

<script>
import zhibochat from "../index/zhibochat_share";

let GME_able = false,
  gmeAPI = null,
  onEvent = null;
// eslint-disable-next-line
try {
  // eslint-disable-next-line
  if (WebGMEAPI) {
    GME_able = true;
    // eslint-disable-next-line
    gmeAPI = new WebGMEAPI();

    //GME事件回调
    // eslint-disable-next-line
    onEvent = function (eventType, result) {
      if (eventType === gmeAPI.event.ITMG_MAIN_EVENT_TYPE_ENTER_ROOM) {
        //alert("EnterRoom");
        console.log("进入房间成功");
        setTimeout(() => {
          gmeAPI.EnableSpeaker(true);
        }, 1000);
      } else if (eventType === gmeAPI.event.ITMG_MAIN_EVENT_TYPE_EXIT_ROOM) {
        //alert("ExitRoom");
        console.log("退出");
      } else if (eventType === gmeAPI.event.ITMG_MAIN_EVENT_TYPE_ROOM_DISCONNECT) {
        //alert("Room Disconnect!!!");
        console.log("GME连接中断");
      }
    };
  }
} catch (error) {
  GME_able = false;
  console.warn("当前浏览器不支持GME的SDK");
  console.warn(error);
}

export default {
  name: "video_voice",
  components: {
    zhibochat,
  },
  data() {
    return {
      cover_img_src: "", //电台背景图
      in_Android: false, //判断是否在安卓
      show_chat: false, //是否显示聊天框
      ready: false, //播放地址是否准备完毕
      is_star: false, //判断用户是否点击了播放
      is_over: false, //判断视频是否播放结束
      info: { avater: "", showcover: "", nickname: "", roomnumber: "" }, //主播信息
      liveUrl: "", //直播流地址
      user_list: [],
      num_bs: 1, //判断是否为多人电台
      wathcer: [], //观众席
      uinfo: {}, //当前用户个人数据
      is_login: true, //判断是否登录
      gme_appid: "1400458882",
      gme_authKey: "gMguLMqthzrKPLPO",
      roomid: "",
    };
  },
  methods: {
    /**openinstall相关事务 */
    open_install_thing() {
      let _this = this;
      /*web页面向app传递的json数据(json string/js Object)，应用被拉起或是首次安装时，通过相应的android/ios api可以获取此数据*/
      // eslint-disable-next-line
      var data = OpenInstall.parseUrlParams(); //openinstall.js中提供的工具函数，解析url中的所有查询参数
      // eslint-disable-next-line
      new OpenInstall(
        {
          /*appKey必选参数，openinstall平台为每个应用分配的ID*/
          appKey: "tj3x4l",
          /*openinstall初始化完成的回调函数，可选*/
          onready: function () {
            var m = this,
              button1 = document.getElementById("live-download1"),
              button2 = document.getElementById("live-download2"),
              button3 = document.getElementById("live-download3"),
              button4 = document.getElementById("live-download4"),
              button5 = document.getElementById("live-download5");
            /*在app已安装的情况尝试拉起app*/
            m.schemeWakeup();
            /*用户点击某个按钮时(假定按钮id为downloadButton)，安装app*/
            button1.onclick = function () {
              m.wakeupOrInstall();
              return false;
            };
            button2.onclick = function () {
              m.wakeupOrInstall();
              return false;
            };
            button3.onclick = function () {
              m.wakeupOrInstall();
              return false;
            };
            if (button4) {
              button4.onclick = function () {
                _this.login_download(m);
                // m.wakeupOrInstall();
                return false;
              };
            }
            if (button5) {
              button5.onclick = function () {
                _this.login_download(m);
                // m.wakeupOrInstall();
                return false;
              };
            }
          },
        },
        data
      );
    },

    //判断当前用户是否登录，如果未登录就登录，已登录就下载
    login_download(m) {
      if (this.$tool.isStr(this.$cookie.getC("token"))) {
        //已经登录
        m.wakeupOrInstall();
      } else {
        //未登录 打开登录界面
        this.$emit("open_reg");
      }
    },

    //播放视频
    play() {
      this.is_star = true;
    },

    //更新热度
    upheat(e) {
      this.info.heat = this.$tool.million(e);
    },

    //更新魅力值
    uppoint(e) {
      this.info.totalpoint = e;
    },

    //直播结束
    end_palying() {
      this.ready = false;
      this.is_star = false;
      this.show_chat = false;
      this.is_over = true;
    },

    /**获取观众席 */
    get_watcher() {
      let _this = this;
      let data = {
        pagesize: 4,
        page: 1,
      };
      this.$jsonp(this.$apis("live_share_watcher"), data, (res) => {
        _this.wathcer = res.data.data.list;
        _this.wathcer.forEach((e) => {
          e.honor = _this.$tool.million(e.honor, "cn");
        });
      });
    },

    /**获取直主播的信息 */
    /**处理播放数据 */
    videoSource() {
      let _this = this;
      let data = {
        type: 1,
      };
      if (this.$route.query.roomnumber) {
        data.roomnumber = this.$route.query.roomnumber;
      } else {
        //跳到分享页
        this.$router.push({ path: "/share" });
        return;
      }
      this.$jsonp(this.$apis("liveUrl"), data, (res) => {
        _this.info = res.data.data.result;
        _this.cover_img_src = _this.info.show_background;

        if (res.data.data.result.is_showing == "0") {
          //已经结束
          _this.is_over = true;
          _this.is_star = false;
        } else {
          _this.get_user_info();
          _this.ready = true;
          _this.is_star = true;
          _this.show_chat = true;
          //正在直播
          _this.info.heat = _this.$tool.million(_this.info.heat);
          _this.$tool.setTitle(_this.info.nickname + "的电台");
          //判断电台人数
          if (_this.info.room_status == 3) {
            _this.num_bs = 9;
            //请求电台席位列表
            _this.get_voice_list();
          } else {
            //组装数据
            _this.user_list = [
              {
                seat_id: 0,
                avatar: _this.info.avatar,
                tousernickname: _this.info.nickname,
              },
            ];
          }
        }
      });
    },

    /**请求电台当前人员 */
    get_voice_list() {
      let _this = this;
      let data = {};
      if (this.$route.query.roomnumber) {
        data.room_user_id = _this.info.userid;
        data.show_id = _this.info.showid;
      } else {
        //跳到分享页
        this.$router.push({ path: "/share" });
        return;
      }
      this.$jsonp(this.$apis("voice_share_userlist"), data, (res) => {
        //组装数据
        _this.user_list = [
          {
            seat_id: 0,
            avatar: _this.info.avatar,
            tousernickname: _this.info.nickname,
          },
          ...res.data.data.list,
        ];
      });
    },

    /**腾讯游戏多媒体引擎鉴权 */
    tx_game_engine() {
      // eslint-disable-next-line
      let authBuffer = new AuthBufferService(
        this.gme_appid,
        // 'cs23403305',
        this.roomid,
        parseInt(this.uinfo.userid * 10000) + "",
        this.gme_authKey
      );
      let userSig = authBuffer.getSignature();
      this.initGMEWithSig(userSig);
    },
    initGMEWithSig(userSig) {
      // eslint-disable-next-line
      gmeAPI.Init(document, this.gme_appid, parseInt(this.uinfo.userid * 10000) + "");
      // eslint-disable-next-line
      gmeAPI.SetTMGDelegate(onEvent);
      // eslint-disable-next-line
      gmeAPI.EnterRoom(this.roomid, 2, userSig);
    },

    /**拿取当前用户的数据，进行音频鉴权 */
    get_user_info() {
      this.is_login = this.$tool.isStr(this.$cookie.getC("token"));
      if (!this.is_login) {
        return false;
      }
      let _this = this;
      this.$jsonp(this.$apis("me"), {}, (res) => {
        _this.uinfo = res.data.data.result;
        _this.roomid = _this.$route.query.roomnumber;
        if (!this.$appProduction) {
          _this.roomid = "8899" + _this.$route.query.roomnumber;
        }
        //开始进行音频鉴权
        if (GME_able) {
          _this.tx_game_engine();
        }
      });
    },

  },
  mounted: function () {
    /**判断是否在安卓 */
    var u = navigator.userAgent;
    this.in_Android = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
    this.videoSource();
    this.get_watcher();
    let _this = this;
    setTimeout(() => {
      _this.open_install_thing();
    }, 1000);
  },
};
</script>

<style scoped>
#video_live {
  z-index: 10;
}
/**直播区域 */
.cover {
  height: 100%;
}
.filter_cover {
  filter: blur(0.4rem);
}
.live {
  height: 350px;
}
.living {
  height: calc(100vh - 70px);
}

/**头像和榜单 */
.top {
  width: 100%;
  top: 0;
  padding: 8px;
  justify-content: space-between;
  z-index: 3;
}
.top .head {
  align-items: center;
  border-radius: 3rem;
  background: rgba(0, 0, 0, 0.3);
  padding-right: 4px;
}
.top .head .img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 8px;
}
.top .img img {
  width: 100%;
  height: 100%;
}
.top .head .p1 {
  max-width: 80px;
  font-size: 12px;
  color: #fff;
}
.top .head .p2 {
  font-size: 9px;
  color: #d4d4d3;
  font-family: kefu;
}
.top .head .gz {
  width: 36px;
  height: 22px;
  margin-left: 10px;
}
/**榜单区域 */
.list-shell {
  max-width: 56%;
  word-break: keep-all;
  white-space: nowrap;
  padding-right: 25px;
}
.list-shell .allA {
  z-index: 5;
}
ul li {
  width: 30px;
  height: 30px;
  margin-right: 6px;
  border-radius: 50%;
}
ul li .head {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
ul li .avatar {
  border-radius: 50%;
}
ul li .head-shell {
  width: 100%;
  top: 0;
  left: 0;
  z-index: 1;
}
ul li span {
  width: 100%;
  text-align: center;
  font-size: 8px;
  color: #fff;
  border-radius: 3rem;
  background: rgba(0, 0, 0, 0.3);
  bottom: 0;
  z-index: 2;
}
ul li:nth-child(1) span {
  background: rgba(252, 176, 64, 0.8);
}
ul li:nth-child(2) span {
  background: rgba(255, 255, 255, 0.8);
}
ul li:nth-child(3) span {
  background: rgba(251, 136, 98, 0.8);
}
.moer-list {
  width: 30px;
  height: 30px;
  right: 0;
  z-index: 4;
}
ul .xuhua {
  width: 25px;
  right: 0;
  background: linear-gradient(to right, rgba(255, 255, 255));
}

/**魅力值 */
.mlz_n {
  padding: 0 8px;
  padding-left: 15px;
  justify-content: space-between;
  top: 50px;
  left: 0;
  width: 100%;
  z-index: 3;
}
.mlz {
  width: auto;
  align-items: center;
  font-size: 10px;
  border-radius: 3rem;
  border: 1px solid #ff67d1;
  padding: 1px;
  color: #fff;
  padding-right: 20px;
  background: rgba(0, 0, 0, 0.4);
}
.mlz .sign {
  width: 19px;
  left: -7px;
}
.mlz .mlz-img {
  width: 52px;
  height: 14px;
  margin-right: 3px;
}
.mlz .arrow {
  width: 6px;
  height: 6px;
  right: 4px;
}
.zbh * {
  vertical-align: middle;
}
.zbh {
  font-size: 13px;
  color: #d4d4d3;
  font-family: kefu;
  align-items: center;
}
.zbh img {
  width: 33px;
  height: 13px;
  display: block;
}

/**底部按钮 */
.b-bottom {
  width: 100%;
  bottom: 8px;
  padding: 0 8px;
  z-index: 3;
}
.b-bottom,
.b-bottom div {
  justify-content: space-between;
  align-items: center;
}
.b-bottom img {
  float: left;
}
.b-bottom .img1 {
  width: 41%;
  margin-right: 6px;
}
.b-bottom .img2 {
  width: 9%;
  float: left;
}
.b-bottom .img3 {
  width: 34%;
  float: right;
}

/**结束区域 */
.over {
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 10;
}
.over p {
  text-align: center;
}
.over .p1 {
  font-size: 20px;
  font-weight: bold;
  color: #d4d4d3;
  margin-top: 72px;
  margin-bottom: 26px;
}
.over .p2 {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 auto;
  margin-bottom: 8px;
}
.over .p2 img {
  width: 100%;
  height: 100%;
}
.over .p3 {
  font-size: 15px;
  color: #fff;
  margin-bottom: 4px;
}
.over .p4 {
  font-size: 12px;
  color: #d4d4d3;
  margin-bottom: 28px;
}
.over .btn {
  width: 41%;
  margin: 0 auto;
}
.over .btn img {
  width: 100%;
}

/**播放按钮 */
.play_btn {
  width: 60px;
  z-index: 2;
}
.chat {
  z-index: 1;
}

/**电台区域 */
.bs {
  width: 100%;
  height: 100%;
}
.bs .allA {
  z-index: 3;
}
.bk_cover_img {
  width: 100%;
  height: 100%;
}
.b_cover {
  width: 100%;
  height: 100%;
  z-index: 1;
  background: rgba(0, 0, 0, 0.1);
}
.ac-head {
  border-radius: 50%;
  z-index: 2;
}
.ac-head {
  width: 18%;
}
.ac-head:nth-child(1) {
  top: 17%;
  width: 21%;
  left: 50%;
  transform: translateX(-50%);
}
.ac-head .head-img {
  position: relative;
  border-radius: 50%;
  z-index: 2;
}
.ac-head .sign-img {
  width: 70%;
  bottom: 0;
  z-index: 3;
}
.in-head::after,
.in-head::before {
  position: absolute;
  content: "";
  width: 80%;
  height: 80%;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  background: rgba(255, 255, 255, 0.5);
  border-radius: 50%;
}
.in-head::after {
  animation: share_bsCircle 2s ease-out infinite;
  z-index: 1;
}
.in-head::before {
  animation: share_bsCircle 2s 0.4s ease-out infinite;
  z-index: 2;
}

.bs .name {
  width: 100%;
  text-align: center;
  font-size: 0.75rem;
  color: #fff;
  bottom: -28%;
  z-index: 2;
}

/**各个头像位置定位 2-9*/
.ac-head:nth-child(2) {
  top: 26%;
  left: 9%;
}
.ac-head:nth-child(3) {
  top: 44%;
  left: 9%;
}
.ac-head:nth-child(4) {
  top: 62%;
  left: 9%;
}
.ac-head:nth-child(5) {
  top: 36%;
  left: 50%;
  transform: translateX(-50%);
}
.ac-head:nth-child(6) {
  top: 54%;
  left: 50%;
  transform: translateX(-50%);
}
.ac-head:nth-child(7) {
  top: 26%;
  right: 9%;
}
.ac-head:nth-child(8) {
  top: 44%;
  right: 9%;
}
.ac-head:nth-child(9) {
  top: 62%;
  right: 9%;
}
</style>
